module.exports = __webpack_public_path__ + "img/01-illu-haruka0125.123fecc8.png";